import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import SubPageLayout from "../components/SubPageLayout";
import { PHONE_TEL, PHONE_DISPLAY } from "../data";

export default function ThankYou() {
  return (
    <SubPageLayout testid="thank-you-page" hideCta eyebrow="Request received" title="Thank You. We'll Be in Touch."
      subtitle="A member of our local team will reach out shortly to schedule your free in-home water test.">
      <section className="section-pad bg-[#F4F1E9]">
        <div className="container-hw max-w-2xl">
          <p className="text-[1.05rem] leading-relaxed text-[#3E474B]">Prefer to talk now? Give us a call and we'll find a time that works for you.</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href={`tel:${PHONE_TEL}`} data-testid="thankyou-call" className="btn-cta"><Phone className="w-4 h-4" strokeWidth={1.5} /> {PHONE_DISPLAY}</a>
            <Link to="/" data-testid="thankyou-home" className="btn-outline">Back to Home</Link>
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
